import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../../components/ui/Button';
import { CheckCircleIcon, CloseIcon } from '../../components/ui/icons';
import { useMeetWeightLossBuddy } from './MeetWeightLossBuddyTutorials';
import './firstPostTutorialCard.css';

interface FirstPostTutorialCardProps {
  onDismiss: () => void;
}

export function FirstPostTutorialCard({
  onDismiss,
}: FirstPostTutorialCardProps) {
  const { t } = useTranslation();
  const { openHomePage } = useMeetWeightLossBuddy();

  const handleWatchHomePage = (): void => {
    onDismiss();
    openHomePage();
  };

  return (
    <aside
      className="first-post-tutorial"
      aria-labelledby="first-post-tutorial-title"
    >
      <span className="first-post-tutorial__icon" aria-hidden>
        <CheckCircleIcon size={22} />
      </span>
      <div className="first-post-tutorial__content">
        <h2 id="first-post-tutorial-title">
          {t('home.newUserWelcome.tutorialCard.title')}
        </h2>
        <p>{t('home.newUserWelcome.tutorialCard.description')}</p>
      </div>
      <Button
        className="first-post-tutorial__watch"
        size="sm"
        variant="ghost"
        onClick={handleWatchHomePage}
      >
        {t('home.newUserWelcome.tutorialCard.watchHomePage')}
      </Button>
      <button
        type="button"
        className="first-post-tutorial__close"
        onClick={onDismiss}
        aria-label={t('home.newUserWelcome.tutorialCard.dismiss')}
      >
        <CloseIcon size={18} />
      </button>
    </aside>
  );
}
